import { useEffect, useState } from "react"
import { FaInfoCircle, FaSpinner, FaTimes } from "react-icons/fa"
import { BACKEND } from "../../config/configEnvs"
import axios from "axios"
import { Button, Pagination } from "@mui/material"
import { toast } from "react-toastify"
import Tooltip from "../ui/ToolTip"
import SearchIcon from '@mui/icons-material/Search';


const TablaEncuestasResueltas = ({ limit }) => {

  const [page, setPage] = useState(1)
  const [totalDocs, setTotalDocs] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  const [loadingStatus, setLoadingStatus] = useState(false)

  const [surveys, setSurveys] = useState([])

  const [searchText, setSearchText] = useState("")

  const getSurveys = async () => { // Obtenemos todas las plantillas de las encuestas
    try {

      let url = `${BACKEND}/api/encuestaSatisfaccionRespuesta?page=${page}&limit=${limit}&depth=5`

      if (searchText) {
        url += `&where[serviceCot.cotizacion.cliente.nombreComercial][equals]=${searchText}`
      }

      setLoadingStatus(true)
      const response = await axios.get(url)
      console.log(url)
      console.log(response)
      setSurveys(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (error) {
      toast.error("Error al obtener las encuestas")
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => {
    getSurveys()
  }, [])

  useEffect(() => {
    getSurveys()
  }, [page, limit])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (searchText === "") {
      getSurveys(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [searchText]);

  const handleResetSearch = () => { // Resetea la búsqueda
    setSearchText(""); // Cambiar el estado
  };

  return (
    <>
      {/*Body */}
      <div className="flex-grow flex flex-col">

      {/* Barra de info y data */}       
      <div className="flex flex-row items-center justify-end bg-gray-100 px-8 gap-8">

        <div className="relative">
          <input
            type="text"
            placeholder="Buscar cliente"
            className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          {searchText && (
            <FaTimes
              onClick={() => handleResetSearch()}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
            />
          )}
        </div>

        <div>
          <Button 
            variant="contained"
            endIcon={<SearchIcon />}
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              fontFamily: "poppins",
              padding: "4px 24px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => getSurveys()}
          >
            Buscar
          </Button>
        </div>

      </div>

        {loadingStatus ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
          ) : (
            surveys.length === 0 ? (
              <div className="flex w-full h-full text-gray-700 items-center justify-center">
                <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                    <span>No hay registros</span>
                    <FaInfoCircle className="text-gray-500" />
                </div>
              </div>
            ) : (
              <table className="w-full table-fixed mt-2">
                <thead className="bg-white sticky top-0 z-50">
                  <tr className="w-full text-gray-700 text-center text-sm uppercase font-semibold">
                    <td className="w-[10%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cliente
                    </td>
                    <td className="w-[10%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Formulario
                    </td>
                    <td className="w-[15%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Descripcion
                    </td>
                    <td className="w-[5%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      F. entrega
                    </td>
                    <td className="w-[5%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Preguntas
                    </td>
                    <td className="w-[5%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Puntos
                    </td>
                    <td className="w-[10%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Encargado
                    </td>
                    <td className="w-[5%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Evidencia
                    </td>
                    <td className="w-[10%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Encuestado
                    </td>
                    <td className="w-[5%] px-3 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Estado
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {surveys.map((s, i) => (
                    <tr
                      key={i}
                      className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300"
                    >
                      <td scope="row" className="w-[15%] px-4 py-2 font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100">  
                        <Tooltip content="Ir al servicio">
                          <a 
                            href={`/home/seguimiento/${s.serviceCot?.cotizacion?.cliente?.id}/${s.serviceCot?.servicio?.name}/${s.serviceCot?.id}/`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            {s.serviceCot?.cotizacion?.cliente?.nombreComercial}
                          </a>
                        </Tooltip> 
                      </td>
                      <td scope="row" className="w-[20%] px-4 py-2 border border-gray-300 text-center transition-all duration-100">
                        {s.survey?.title}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.survey?.description ? s.survey.description : "-"}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.answered ? new Date(s.deliverDate).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' }) : "-"}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.answers?.length ? s.answers?.length : "-"}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {/* {s.answers?.length ? s.answers.reduce((acc, q) => {return acc + q.score}, 0) : "-"} */}
                        {s.answers ? (
                          (() => {
                            const result = s.answers.reduce(
                              (acc, answer) => {
                                acc.totalScore += answer.score;
                                acc.maxScore += answer.question.maxScore;
                                return acc;
                              },
                              { totalScore: 0, maxScore: 0 }
                            );
                            return `${result.totalScore} / ${result.maxScore}`;
                          })()
                        ) : (
                          <span className="text-xs text-gray-700">-</span>
                        )}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.worker ? s.worker.name : "-"}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.evidence && s.evidence.length > 0 ? (
                          <Tooltip 
                            interactive={true}
                            content={
                              <div className="flex flex-col gap-2">
                                {s.evidence.map((e, i) => (
                                  <div key={i} className="flex flex-row items-center justify-center gap-2">
                                    <span className="text-xs">Link:</span>
                                    <a 
                                      key={i}
                                      href={e.url} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      className="text-white hover:underline text-xs block text-left"
                                    >
                                      {e.filename || `Evidencia ${i + 1}`}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            }
                          >
                            <span className="text-xs text-blue-600 hover:text-blue-800 underline cursor-pointer">
                              Ver evidencias ({s.evidence.length})
                            </span>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.surveyed ? s.surveyed : "-"}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        <span className={`text-xs font-bold ${s.answered ? "text-green-500" : "text-red-500"}`}>{s.answered ? "Respondido" : "No respondido"}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <div className="w-full flex flex-col gap-4 py-4 justify-center items-center ">
        <span className="text-sm text-gray-700 dark:text-gray-500 ">
          Mostrando
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {surveys.length}
          </span>{" "}
          de
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {totalDocs}
          </span>{" "}
          encuestas
        </span>
        <Pagination 
          count={totalPages}
          page={page}
          variant="outlined" 
          shape="rounded"
          onChange={handlePageChange}
        />
      </div>
    </>
  )
}

export default TablaEncuestasResueltas